"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateVideo = void 0;
var tslib_1 = require("tslib");
var video_utils_1 = require("./video.utils");
var private_catalog_service_1 = require("../../../catalog-services/private-catalog-service");
var PrivateVideo = /** @class */ (function (_super) {
    tslib_1.__extends(PrivateVideo, _super);
    function PrivateVideo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param videos - array of videos
     * @param requestConfig
     */
    PrivateVideo.prototype.createVideos = function (videos, requestConfig) {
        return this.post('/catalog/items', { items: videos }, requestConfig);
    };
    /**
     * @param query
     * @param tag
     * @param category
     * @param mediaType
     * @param sort
     * @param paging
     * @param itemType
     * @param requestConfig
     */
    PrivateVideo.prototype.getList = function (_a, requestConfig) {
        var query = _a.query, tag = _a.tag, category = _a.category, mediaType = _a.mediaType, sort = _a.sort, paging = _a.paging, itemType = _a.itemType;
        var params = (0, video_utils_1.mapOptionsToQueryParams)({
            query: query,
            tag: tag,
            category: category,
            mediaType: mediaType,
            sort: sort,
            paging: paging,
            itemType: itemType,
        });
        return this.get('/catalog/items', tslib_1.__assign({ params: params }, requestConfig));
    };
    /**
     * @param videoIds - array of video ids
     * @param requestConfig
     */
    PrivateVideo.prototype.removeVideos = function (videoIds, requestConfig) {
        return this.delete('/catalog/items/delete', tslib_1.__assign(tslib_1.__assign({}, requestConfig), { params: { items: videoIds } }));
    };
    /**
     * @param videoId
     * @param requestConfig
     */
    PrivateVideo.prototype.getById = function (videoId, requestConfig) {
        return this.get("/catalog/items/".concat(videoId), requestConfig);
    };
    /**
     * @param videoId
     * @param video
     * @param requestConfig
     */
    PrivateVideo.prototype.updateById = function (videoId, video, requestConfig) {
        return this.put("/catalog/items/".concat(videoId), video, tslib_1.__assign({}, requestConfig));
    };
    PrivateVideo.prototype.patchById = function (videoId, video, requestConfig) {
        return this.patch("/catalog/items/".concat(videoId), video, tslib_1.__assign({}, requestConfig));
    };
    /**
     * @param videoIds
     * @param video
     * @param requestConfig
     */
    PrivateVideo.prototype.batchUpdateVideos = function (videoIds, video, requestConfig) {
        var data = tslib_1.__assign(tslib_1.__assign({}, video), { items: videoIds });
        return this.put("/catalog/items", data, tslib_1.__assign({}, requestConfig));
    };
    PrivateVideo.prototype.getVideoUrlsByFileName = function (name, _a, requestConfig) {
        var _b = _a === void 0 ? {} : _a, clip = _b.clip;
        return this.get("/catalog/videos/".concat(name, "/play"), tslib_1.__assign({ params: {
                clip: clip,
            } }, requestConfig));
    };
    /**
     * @param {string} videoId
     * @param requestConfig
     */
    PrivateVideo.prototype.createSingleVideo = function (videoId, requestConfig) {
        return this.post("/publisher/items/".concat(videoId, "/create"), null, requestConfig);
    };
    PrivateVideo.prototype.generateVideoTrailer = function (videoId) {
        return this.post("/catalog/items/".concat(videoId, "/generate-trailer"));
    };
    return PrivateVideo;
}(private_catalog_service_1.PrivateCatalogService));
exports.PrivateVideo = PrivateVideo;
//# sourceMappingURL=video.js.map